exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-transition-preview-WWSR1{position:relative}", ""]);

// Exports
exports.locals = {
	"transition-preview": "index-transition-preview-WWSR1"
};